import * as React from "react";
const SvgSwap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 10 8"
    {...props}
  >
    <path
      fill="#091E42"
      d="M7.325 4.562a.36.36 0 0 1 0-.525l1.25-1.25H5a.364.364 0 0 1-.375-.375A.364.364 0 0 1 5 2.037h3.575L7.313.775a.331.331 0 0 1-.106-.256.378.378 0 0 1 .118-.257.36.36 0 0 1 .525 0L9.738 2.15c.042.042.07.083.087.125a.367.367 0 0 1 .025.137c0 .05-.008.096-.025.138a.38.38 0 0 1-.087.125l-1.9 1.9a.331.331 0 0 1-.256.106.377.377 0 0 1-.257-.119ZM2.15 7.737.263 5.85a.38.38 0 0 1-.088-.125.367.367 0 0 1-.025-.138c0-.05.009-.095.025-.137a.381.381 0 0 1 .088-.125l1.9-1.9a.331.331 0 0 1 .256-.106.378.378 0 0 1 .256.118.36.36 0 0 1 0 .525l-1.25 1.25H5a.364.364 0 0 1 .375.375.364.364 0 0 1-.375.375H1.425l1.263 1.263c.075.075.11.16.106.256a.378.378 0 0 1-.119.256.36.36 0 0 1-.525 0Z"
    />
  </svg>
);
export default SvgSwap;
